import './style.css';
import { isSupabaseConfigured } from './lib/supabaseClient.js';
import {
  signIn, signUp, signOut, requestPasswordReset, updatePassword,
  getSession, onAuthStateChange, getMyProfile,
} from './lib/auth.js';
import { fetchCatalog } from './lib/catalogRepo.js';
import { fetchCodigosParo } from './lib/parosRepo.js';
import { subscribeToCatalogChanges, subscribeToParosChanges } from './lib/realtime.js';
import { applyData, initEventListeners, initSimulador, applyParosData } from './legacy/appLogic.js';
import { renderAdminList, initAdminUI } from './lib/admin.js';

let unsubscribeRealtime = null;
let unsubscribeParosRealtime = null;
let simuladorInicializado = false;

// Solo estas cuentas están autorizadas para registrarse. La validación
// real (imposible de saltarse) vive en Supabase, en el trigger
// handle_new_user(); esta lista solo da un mensaje inmediato en el
// navegador sin esperar la respuesta del servidor.
const CORREOS_AUTORIZADOS = [
  'eperez@unsoloproveedorzf.com',
  'pproduccion@unsoloproveedorzf.com',
  'operacioneszf@unsoloproveedorzf.com',
  'liderproduccionzf@unsoloproveedorzf.com',
  'j.restrepo@unsoloproveedor.com',
];
function correoAutorizado(email) {
  return CORREOS_AUTORIZADOS.includes((email || '').trim().toLowerCase());
}

function $(id) { return document.getElementById(id); }

function showAuthScreen() {
  $('authScreen').style.display = 'flex';
  $('appContent').style.display = 'none';
  if (unsubscribeRealtime) { unsubscribeRealtime(); unsubscribeRealtime = null; }
  if (unsubscribeParosRealtime) { unsubscribeParosRealtime(); unsubscribeParosRealtime = null; }
}

function showAppContent() {
  $('authScreen').style.display = 'none';
  $('appContent').style.display = '';
}

function showAuthMessage(kind, msg) {
  const errBox = $('authError');
  const infoBox = $('authInfo');
  errBox.style.display = 'none';
  infoBox.style.display = 'none';
  if (kind === 'error') { errBox.textContent = msg; errBox.style.display = 'block'; }
  if (kind === 'info') { infoBox.textContent = msg; infoBox.style.display = 'block'; }
}

function switchAuthForm(which) {
  ['loginForm', 'signupForm', 'resetForm', 'updatePasswordForm'].forEach(id => {
    $(id).style.display = id === which ? '' : 'none';
  });
  showAuthMessage(null, '');
}

async function bootstrapAppContent() {
  showAppContent();
  try {
    const profile = await getMyProfile();
    const isAdmin = profile?.role === 'admin';
    $('userBadge').textContent = `${profile?.email || ''} · ${isAdmin ? 'ADMIN' : 'OPERADOR'}`;
    $('tabBtnAdmin').style.display = isAdmin ? '' : 'none';

    const data = await fetchCatalog();
    applyData(data);
    // Los códigos de parada se cargan aparte y con manejo de error propio:
    // si la tabla codigos_paro todavía no existe en Supabase (p. ej. no se
    // ha corrido el SQL de carga), el catálogo principal debe seguir
    // funcionando igual; la pestaña "Tiempos de Cambio" solo queda vacía.
    try {
      const parosData = await fetchCodigosParo();
      applyParosData(parosData);
    } catch (err) {
      console.error('[bootstrap] error cargando códigos de parada:', err);
      applyParosData([]);
    }
    // El simulador se inicializa una sola vez (no en cada refresco de
    // realtime) para no perder la selección en curso del usuario.
    if (!simuladorInicializado) {
      initSimulador();
      simuladorInicializado = true;
    }

    if (unsubscribeRealtime) unsubscribeRealtime();
    unsubscribeRealtime = subscribeToCatalogChanges((freshData) => applyData(freshData));
    if (unsubscribeParosRealtime) unsubscribeParosRealtime();
    unsubscribeParosRealtime = subscribeToParosChanges((freshParos) => applyParosData(freshParos));

    if (isAdmin) {
      initAdminUI();
      renderAdminList('');
    }
  } catch (err) {
    console.error('[bootstrap] error cargando catálogo:', err);
    showAuthMessage('error', 'No se pudo cargar el catálogo: ' + err.message);
  }
}

function wireAuthForms() {
  $('loginForm').addEventListener('submit', async (e) => {
    e.preventDefault();
    showAuthMessage(null, '');
    try {
      await signIn($('loginEmail').value.trim(), $('loginPassword').value);
    } catch (err) {
      showAuthMessage('error', traducirErrorAuth(err.message));
    }
  });

  $('signupForm').addEventListener('submit', async (e) => {
    e.preventDefault();
    showAuthMessage(null, '');
    const email = $('signupEmail').value.trim();
    if (!correoAutorizado(email)) {
      showAuthMessage('error', 'Este correo no está autorizado para crear una cuenta. Contacta a un administrador.');
      return;
    }
    try {
      await signUp(email, $('signupPassword').value);
      showAuthMessage('info', 'Cuenta creada. Revisa tu correo para confirmar la cuenta antes de iniciar sesión.');
      switchAuthForm('loginForm');
    } catch (err) {
      showAuthMessage('error', traducirErrorAuth(err.message));
    }
  });

  $('resetForm').addEventListener('submit', async (e) => {
    e.preventDefault();
    showAuthMessage(null, '');
    try {
      await requestPasswordReset($('resetEmail').value.trim());
      showAuthMessage('info', 'Si el correo existe, te enviamos un enlace para restablecer la contraseña.');
    } catch (err) {
      showAuthMessage('error', traducirErrorAuth(err.message));
    }
  });

  $('updatePasswordForm').addEventListener('submit', async (e) => {
    e.preventDefault();
    showAuthMessage(null, '');
    try {
      await updatePassword($('newPassword').value);
      showAuthMessage('info', 'Contraseña actualizada. Ya puedes usarla para iniciar sesión.');
      switchAuthForm('loginForm');
    } catch (err) {
      showAuthMessage('error', traducirErrorAuth(err.message));
    }
  });

  $('gotoSignup').addEventListener('click', (e) => { e.preventDefault(); switchAuthForm('signupForm'); });
  $('gotoReset').addEventListener('click', (e) => { e.preventDefault(); switchAuthForm('resetForm'); });
  $('gotoLoginFromSignup').addEventListener('click', (e) => { e.preventDefault(); switchAuthForm('loginForm'); });
  $('gotoLoginFromReset').addEventListener('click', (e) => { e.preventDefault(); switchAuthForm('loginForm'); });

  $('logoutBtn').addEventListener('click', async () => {
    try { await signOut(); } catch (err) { console.error(err); }
  });
}

function traducirErrorAuth(msg) {
  const m = (msg || '').toLowerCase();
  if (m.includes('invalid login credentials')) return 'Correo o contraseña incorrectos.';
  if (m.includes('user already registered')) return 'Ya existe una cuenta con ese correo.';
  if (m.includes('password should be at least')) return 'La contraseña debe tener al menos 8 caracteres.';
  if (m.includes('correo_no_autorizado')) return 'Este correo no está autorizado para crear una cuenta. Contacta a un administrador.';
  if (m.includes('email not confirmed')) return 'Debes confirmar tu correo antes de iniciar sesión.';
  return msg;
}

async function main() {
  if (!isSupabaseConfigured) {
    document.body.innerHTML = `<div style="padding:40px;font-family:sans-serif;">
      <h2>Configuración incompleta</h2>
      <p>Faltan las variables de entorno <code>VITE_SUPABASE_URL</code> y <code>VITE_SUPABASE_ANON_KEY</code>.
      Consulta el README/DEPLOY.md para configurarlas.</p>
    </div>`;
    return;
  }

  initEventListeners();
  wireAuthForms();

  onAuthStateChange((event, session) => {
    if (event === 'PASSWORD_RECOVERY') {
      showAuthScreen();
      switchAuthForm('updatePasswordForm');
      return;
    }
    if (session) {
      bootstrapAppContent();
    } else {
      showAuthScreen();
      switchAuthForm('loginForm');
    }
  });

  const session = await getSession();
  if (session) {
    bootstrapAppContent();
  } else {
    showAuthScreen();
  }
}

main();
